import { useEffect } from 'react'
import { ToggleComponent } from '../../assets/ts/components'

const ATRIBUTO = 'data-kt-aside-minimize'

// O estado é o mesmo do botão do header (ToggleComponent → atributo no body). Pela instância,
// o botão também fica marcado como ativo; sem ela (antes do MasterInit), só o atributo.
const alternar = (recolher: boolean) => {
  const botao = document.getElementById('kt_aside_toggle')
  const toggle = botao ? (ToggleComponent.getInstance(botao) as ToggleComponent | null) : null
  if (toggle) {
    if (recolher) toggle.enable()
    else toggle.disable()
  } else if (recolher) {
    document.body.setAttribute(ATRIBUTO, 'on')
  } else {
    document.body.removeAttribute(ATRIBUTO)
  }
}

/**
 * Recolhe o menu lateral enquanto a tela estiver aberta, para dar largura ao conteúdo (ex.:
 * prescrição). Ao sair, devolve o menu como estava, a não ser que o usuário o tenha aberto de
 * novo no meio do caminho. No mobile o menu já é gaveta e o atributo não tem efeito.
 */
export const useMenuLateralRecolhido = () => {
  useEffect(() => {
    if (document.body.getAttribute(ATRIBUTO) === 'on') return
    alternar(true)
    return () => {
      if (document.body.getAttribute(ATRIBUTO) === 'on') alternar(false)
    }
  }, [])
}
